import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

function createFormData(data) {
  var formData = new FormData();
  var keys = Object.keys(data);
  keys.forEach(function (key) {
    return formData.append(key, data[key]);
  });
  return formData;
}

function normalizeUID(uid) {
  return uid === "home" ? null : uid;
}

function sanitizePath(path) {
  return path.replace(/(^\/|\/$)/g, "");
}

function castArray(value) {
  return Array.isArray(value) ? value : [value];
}

function zipWith(callback, arrOne, arrTwo) {
  var a = castArray(arrOne);
  var b = castArray(arrTwo);
  var length = Math.max(a.length, b.length);

  if (length === 0) {
    return [true];
  }

  var res = [];

  for (var i = 0; i < length; i++) {
    res[i] = callback(a[i], b[i]);
  }

  return res;
}

function pairsEq(pairsA, pairsB) {
  return zipWith(function (itemA, itemB) {
    return itemA === itemB;
  }, pairsA, pairsB);
}

function getNormalizedUID(node) {
  if (node == null ? void 0 : node.uid) {
    return normalizeUID(node == null ? void 0 : node.uid);
  }

  return null;
}

function getNormalizedSlug(node) {
  var _a, _b;

  if ((_a = node == null ? void 0 : node.slugs) == null ? void 0 : _a.length) {
    return normalizeUID((_b = node == null ? void 0 : node.slugs) == null ? void 0 : _b[0]);
  }

  if (node == null ? void 0 : node.uid) {
    return getNormalizedUID(node);
  }

  return null;
}

function isBrowser() {
  return typeof window !== "undefined";
}

var INTERNAL_REGEX = /^\/(?!\/)/;

function isInternal(url) {
  return INTERNAL_REGEX.test(url);
}

function isPathActive(path, location) {
  var sanitizedPath = sanitizePath(path);
  var sanitizedLocationPath = sanitizePath((location == null ? void 0 : location.pathname) || "");

  if (!sanitizedPath.length || !sanitizedLocationPath.length) {
    return false;
  }

  return sanitizedLocationPath.startsWith(sanitizedPath);
}

function isPathActiveExact(path, location) {
  var sanitizedPath = sanitizePath(path);
  var sanitizedLocationPath = sanitizePath((location == null ? void 0 : location.pathname) || "");
  return sanitizedPath === sanitizedLocationPath;
}

function postNetlifyForm(_x) {
  return _postNetlifyForm.apply(this, arguments);
}

function _postNetlifyForm() {
  _postNetlifyForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var formName, data, _ref$fetch, fetch, recaptchaResponse, response, status;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            formName = _ref.formName, data = _ref.data, _ref$fetch = _ref.fetch, fetch = _ref$fetch === void 0 ? window == null ? void 0 : window.fetch : _ref$fetch, recaptchaResponse = _ref.recaptchaResponse;
            _context.prev = 1;
            data.set("form-name", formName);

            if (recaptchaResponse) {
              data.set("g-recaptcha-response", String(recaptchaResponse));
            }

            _context.next = 6;
            return fetch("/", {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              },
              body: new URLSearchParams(data).toString()
            });

          case 6:
            response = _context.sent;
            status = (response == null ? void 0 : response.status) || 0;
            return _context.abrupt("return", status >= 200 && status < 300);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);
            return _context.abrupt("return", false);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 11]]);
  }));
  return _postNetlifyForm.apply(this, arguments);
}

function propPairsEq(key, obj1, obj2) {
  if (obj1 === void 0 && obj2 === void 0) {
    return [false];
  }

  return pairsEq(obj1 == null ? void 0 : obj1[key], obj2 == null ? void 0 : obj2[key]);
}

function undefIfEmpty(value) {
  var t = typeof value === "object" && value !== null ? Object.keys(value) : value;
  return (t == null ? void 0 : t.length) ? value : void 0;
}

var ANCHOR_REGEX$1 = /#\S*$/;

function extractAnchor(url) {
  var _a;

  return (_a = url.match(ANCHOR_REGEX$1)) == null ? void 0 : _a[0];
}

var ANCHOR_REGEX = /^https?:\/\/#/;

function isAnchorOnly(url) {
  return ANCHOR_REGEX.test(url);
}

export { createFormData, extractAnchor, getNormalizedSlug, getNormalizedUID, isAnchorOnly, isBrowser, isInternal, isPathActive, isPathActiveExact, postNetlifyForm, propPairsEq, undefIfEmpty };